import React, { useEffect, useState } from 'react';
import { Ionicons } from '@expo/vector-icons';
import { router } from 'expo-router';

import { ThemedText } from '@/components/themed-text';
import { PressableScale } from '@/components/ui/pressable-scale';
import { getStoredGuestSession } from '@/hooks/use-public-schedule';
import { useAuthStore } from '@/store/authStore';

const BRAND = '#FD5001';

/**
 * Caminho de volta do convidado: quem já agendou por este device consegue
 * reabrir seus agendamentos sem depender do link mágico do WhatsApp. Só
 * aparece quando existe telefone verificado guardado (e ninguém logado — com
 * conta, a agenda vive na área do cliente).
 */
export function GuestAppointmentsFab() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const [hasSession, setHasSession] = useState(false);

  useEffect(() => {
    void getStoredGuestSession().then((session) => setHasSession(!!session));
  }, []);

  if (isAuthenticated || !hasSession) return null;

  return (
    <PressableScale
      onPress={() => router.push('/agendamento')}
      className="absolute bottom-6 right-5 flex-row items-center gap-2 rounded-full px-5 py-3.5 shadow-lg"
      style={{ backgroundColor: BRAND, borderCurve: 'continuous' }}
    >
      <Ionicons name="calendar-outline" size={18} color="#fff" />
      <ThemedText className="text-sm font-bold text-white">
        Meus agendamentos
      </ThemedText>
    </PressableScale>
  );
}
